import {useEventBus} from "./use-event-bus";

export class Header {
    private readonly scrolledClass = 'scrolled';
    private readonly openClass = 'open';
    private readonly searchOpenClass = 'search-open';
    private readonly iconMenuClass = 'icon-brhp-menu';
    private readonly iconCloseClass = 'icon-brhp-close';
    private readonly searchClass = '.hd-header-search';
    private readonly buttonSearchClass = '.hd-button-search';
    private readonly idToggle = '#nav-toggle';
    private readonly idOpen = '#nav-open';
    private readonly idClose = '#nav-close';
    private readonly mobileBreakpoint = 991;

    private bodyEl: HTMLElement;
    private el: HTMLElement;
    private toggleEl: HTMLElement | null;
    private openEl: HTMLElement | null;
    private closeEl: HTMLElement | null;
    private logoEl: HTMLElement | null;
    private searchEl: HTMLElement | null;
    private searchToggleEl: HTMLElement | null;
    private mainContentEl: HTMLElement | null;
    private menuItemsWithChildrenEls: HTMLElement[];

    private isOpen = false;
    private isOpenSearch = false;

    private scrollFn;
    private toggleFn;
    private openFn;
    private closeFn;
    private resizeFn;
    private searchFn;
    private menuItemsWithChildrenFns: any[] = [];

    constructor(el) {
        this.bodyEl = document.body;
        this.el = el;
        this.toggleEl = el.querySelector(this.idToggle);
        this.openEl = el.querySelector(this.idOpen);
        this.closeEl = el.querySelector(this.idClose);
        this.searchEl = el.querySelector(this.searchClass);
        this.searchToggleEl = el.querySelector(this.buttonSearchClass);
        this.mainContentEl = el.querySelector('.hd-header-main__content');
        this.logoEl = this.toggleEl && this.toggleEl.querySelector('.icon-brhp');
        this.menuItemsWithChildrenEls = <HTMLElement[]>Array.from(el.querySelectorAll('.menu-item-has-children > a'));
    }

    onInit() {
        this.scrollFn = this.onScroll.bind(this);
        window.addEventListener('scroll', this.scrollFn);
        this.resizeFn = this.onResize.bind(this);
        window.addEventListener('resize', this.resizeFn);
        if (this.toggleEl) {
            this.toggleFn = this.onToggle.bind(this);
            this.toggleEl.addEventListener('click', this.toggleFn);
        }
        if (this.openEl) {
            this.openFn = this.open.bind(this);
            this.openEl.addEventListener('click', this.openFn);
        }
        if (this.closeEl) {
            this.closeFn = this.close.bind(this);
            this.closeEl.addEventListener('click', this.closeFn);
        }
        if (this.searchToggleEl) {
            this.searchFn = this.onSearch.bind(this);
            this.searchToggleEl.addEventListener('click', this.searchFn);
        }
        this.initMenuItemHasChildren();
        this.onScroll();
    }

    onDestroy() {
        if (this.scrollFn) {
            window.removeEventListener('scroll', this.scrollFn);
        }
        if (this.resizeFn) {
            window.removeEventListener('resize', this.resizeFn);
        }
        if (this.searchToggleEl && this.searchFn) {
            this.searchToggleEl.removeEventListener('click', this.searchFn);
        }
        if (this.toggleEl && this.toggleFn) {
            this.toggleEl.removeEventListener('click', this.toggleFn);
        }
        if (this.openEl && this.openFn) {
            this.openEl.removeEventListener('click', this.openFn);
        }
        if (this.closeEl && this.closeFn) {
            this.closeEl.removeEventListener('click', this.closeFn);
        }
        if (this.menuItemsWithChildrenFns && this.menuItemsWithChildrenFns.length > 0) {
            this.menuItemsWithChildrenFns.forEach((item: any) => {
                item.el.removeEventListener(item.event, item.fn);
            });
        }
    }
    private initMenuItemHasChildren() {
        if (!this.menuItemsWithChildrenEls || this.menuItemsWithChildrenEls.length === 0) {
            return;
        }
        this.menuItemsWithChildrenEls.forEach((el) => {
            const fn = this.onClickMenuItemHasChildren.bind(this, el);
            this.menuItemsWithChildrenFns.push({
                el,
                fn,
                event: 'click',
            });
            el.addEventListener('click', fn);
        });
    }

    onClickMenuItemHasChildren(el, event) {
        const parent = el.parentElement;
        if (parent.classList.contains('open')) {
            parent.classList.remove('open');
        } else {
            parent.classList.add('open');
            if (window.innerWidth < this.mobileBreakpoint) {
                event.preventDefault();
            }
        }
    }


    private onSearch() {
        this.isOpenSearch ? this.closeSearch() : this.openSearch();
    }

    private onToggle() {
        this.isOpen ? this.close() : this.open();
    }

    private onScroll() {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 0) {
            this.el.classList.add(this.scrolledClass);
        } else {
            this.el.classList.remove(this.scrolledClass);
        }
    }

    private onResize() {
        const width = window.innerWidth;
        if (this.isOpen && width >= this.mobileBreakpoint) {
            this.close();
        }
    }

    private closeSearch() {
        if (!this.searchEl) {
            return;
        }
        this.isOpenSearch = false;
        this.searchEl.classList.remove(this.openClass);
        this.el.classList.remove(this.searchOpenClass);
    }

    private openSearch() {
        if (!this.searchEl) {
            return;
        }
        this.isOpenSearch = true;
        const form = this.searchEl.querySelector('form');
        const input = this.searchEl.querySelector('input');
        if (input) {
            input.value = '';
            input.focus();
            input.addEventListener('input', (event) => {
                if (!form || !event || !event.target) {
                    return;
                }
                if ((<HTMLInputElement>event.target).value.trim().length > 0) {
                    form.classList.add('has-value');
                } else {
                    form.classList.remove('has-value');
                }
            });
        }
        this.searchEl.classList.add(this.openClass);
        this.el.classList.add(this.searchOpenClass);
    }

    private close() {
        this.bodyEl.style.overflow = 'auto';
        this.isOpen = false;
        this.el.classList.remove(this.openClass);
        if (this.logoEl) {
            this.logoEl.classList.add(this.iconMenuClass);
            this.logoEl.classList.remove(this.iconCloseClass);
        }
        this.closeSearch();
    }

    private open() {
        this.bodyEl.style.overflow = 'hidden';
        this.isOpen = true;
        this.el.classList.add(this.openClass);
        if (this.logoEl) {
            this.logoEl.classList.add(this.iconCloseClass);
            this.logoEl.classList.remove(this.iconMenuClass);
        }
        if (this.mainContentEl) {
            this.mainContentEl.scrollTop = 0;
        }
    }

}

export function useHeader() {
    useEventBus('hd-header-main', Header);
}